import { TypographyFontType } from 'common/types/typography.types';

export enum FontType {
  HERO = 'hero',
  FACTS = 'facts',
  HEADLINE1 = 'headline-1',
  HEADLINE2 = 'headline-2',
  HEADLINE3 = 'headline-3',
  HEADLINE4 = 'headline-4',
  COPY_LARGE = 'copy-large',
  COPY_LARGE_BOLD = 'copy-large-bold',
  COPY_SMALL = 'copy-small',
  COPY_SMALL_MEDIUM = 'copy-small-medium',
  COPY_SMALL_BOLD = 'copy-small-bold',
  TOP_LINE_LARGE = 'top-line-large',
  TOP_LINE_SMALL = 'top-line-small',
  COPY_EXTRA_SMALL = 'copy-extra-small',
  COPY_MEDIUM_SMALL = 'copy-medium-small',
  COPY_SMALL_MEDIUM_BOLD = 'copy-medium-small-bold',
  HEADLINE11 = 'headline-1-1',
}

export const TypographyFontStyles: TypographyFontType = {
  hero: {
    desktop: {
      fontWeight: '600',
      fontSize: '56px',
      lineHeight: '64px',
      letterSpacing: '0.25px',
      fontFamily: 'Eina 03',
    },
    mobile: { fontSize: '24px', lineHeight: '28px', fontFamily: 'Eina 03' },
  },
  facts: {
    desktop: { fontWeight: '800', fontSize: '42px', lineHeight: '44px', letterSpacing: '0.3px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '32px', lineHeight: '32px', fontFamily: 'Eina 03' },
  },
  'headline-1': {
    desktop: {
      fontWeight: '600',
      fontSize: '32px',
      lineHeight: '38px',
      letterSpacing: '0.25px',
      fontFamily: 'Eina 03',
    },
    mobile: { fontSize: '24px', lineHeight: '28px', fontFamily: 'Eina 03' },
  },
  'headline-1-1': {
    desktop: {
      fontWeight: '600',
      fontSize: '32px',
      lineHeight: '38px',
      letterSpacing: '0.25px',
      fontFamily: 'Eina 03',
    },
    mobile: { fontSize: '20px', lineHeight: '24px', fontFamily: 'Eina 03' },
  },
  'headline-2': {
    desktop: {
      fontWeight: '600',
      fontSize: '26px',
      lineHeight: '32px',
      letterSpacing: '0.25px',
      fontFamily: 'Eina 03',
    },
    mobile: { fontSize: '20px', lineHeight: '24px', fontFamily: 'Eina 03' },
  },

  'headline-3': {
    desktop: { fontWeight: '600', fontSize: '18px', lineHeight: '24px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '16px', fontFamily: 'Eina 03' },
  },

  'headline-4': {
    desktop: { fontWeight: '600', fontSize: '18px', lineHeight: '24px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '16px', lineHeight: '18px', fontFamily: 'Eina 03' },
  },

  'copy-large': {
    desktop: { fontWeight: '500', fontSize: '16px', lineHeight: '22px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '18px', fontFamily: 'Eina 03' },
  },

  'copy-large-bold': {
    desktop: { fontWeight: '600', fontSize: '16px', lineHeight: '22px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '18px', fontFamily: 'Eina 03' },
  },

  'copy-small': {
    desktop: { fontWeight: '400', fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '12px', lineHeight: '16px', fontFamily: 'Eina 03' },
  },

  'copy-small-medium': {
    desktop: { fontWeight: '500', fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
  },

  'copy-medium-small': {
    desktop: { fontWeight: '400', fontSize: '16px', lineHeight: '22px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '22px', fontFamily: 'Eina 03' },
  },

  'copy-medium-small-bold': {
    desktop: { fontWeight: '600', fontSize: '16px', lineHeight: '22px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '14px', lineHeight: '22px', fontFamily: 'Eina 03' },
  },

  'copy-small-bold': {
    desktop: { fontWeight: '600', fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
    mobile: { fontWeight: '600', fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
  },

  'top-line-large': {
    desktop: { fontWeight: '500', fontSize: '18px', lineHeight: '22px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '16px', lineHeight: '20px', fontFamily: 'Eina 03' },
  },

  'top-line-small': {
    desktop: { fontWeight: '400', fontSize: '14px', lineHeight: '20px', fontFamily: 'Eina 03' },
    mobile: { fontSize: '12px', lineHeight: '16px', fontFamily: 'Eina 03' },
  },

  'copy-extra-small': {
    desktop: { fontWeight: '600', fontSize: '12px', lineHeight: '16px', fontFamily: 'Eina 03' },
  },
};
